import TaskContainer from "../../components/applications/tasks";

const Tasks = () => {
  return <TaskContainer />;
};

export default Tasks;
